import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Col } from "react-bootstrap";
import _ from "lodash";
import moment from "moment";

import AdminTable from "../../../../components/common/table/AdminTable";
import AdvancedSearch from "../components/advancedSearch/Filters";
import { TableExportButton } from "../../../../components/common/table/TableExportButton";
import TableOptions from "../../../../components/common/table/TableOptions";
import Filters from "./Filters";
import styles from "./AdminUsers.scss";

import parseAdvancedSearch from "../../../../utils/parseAdvancedSearch";
import parseFilters from "../../../../utils/parseFilters";
import {
  encodeSearchParams,
  getFinalQueryString,
  getPageQueryString
} from "../../../../utils/parseQueries";
import parseSortData from "../../../../utils/parseSortData";

const tableColumns = [
  {
    headerText: "FIRST NAME",
    accessor: "first_name",
    sortable: true
  },
  {
    headerText: "LAST NAME",
    accessor: "last_name",
    sortable: true
  },
  {
    headerText: "EMAIL ADDRESS",
    accessor: "email",
    sortable: true
  },
  {
    headerText: "STATUS",
    accessor: "status",
    sortable: true
  },
  {
    headerText: "LEVEL",
    accessor: "level",
    sortable: true
  },
  {
    headerText: "METRO AREA",
    accessor: "metro_area",
    sortable: false
  },
  {
    headerText: "SKILLS",
    accessor: "skills_categories",
    sortable: false
  },
  {
    headerText: "SIGNED UP",
    accessor: "date_signed_up",
    sortable: true
  },
  {
    headerText: "LAST LOGIN",
    accessor: "last_login_date",
    sortable: true
  },
  {
    headerText: "REFERRAL TYPE",
    accessor: "referral_type",
    sortable: true
  },
  {
    headerText: "REFERRAL VALUE",
    accessor: "referral_value",
    sortable: true
  },
  {
    headerText: "# PITCHED",
    accessor: "projects_pitched",
    sortable: true
  },
  {
    headerText: "# WON",
    accessor: "projects_hired",
    sortable: true
  }
];

const STATUS_ID_SIGNED_UP = 4;
const STATUS_ID_APPROVED = 8;

class AdminUsers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      advancedSearch: props.advancedSearch || [],
      filters: props.filters || [],
      currentPage: props.page || 1,
      showAdvancedSearch: false,
      showFilters: false
    };

    this.handleSubmitAdvancedSearch = this.handleSubmitAdvancedSearch.bind(
      this
    );
    this.handleSubmitFilters = this.handleSubmitFilters.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.onSortChange = this.onSortChange.bind(this);
    this.openAdvancedSearch = this.openAdvancedSearch.bind(this);
    this.openFilters = this.openFilters.bind(this);
  }

  handleSubmitAdvancedSearch(data) {
    const advancedSearch = parseAdvancedSearch(data.filters);
    const filters = parseFilters(this.state.filters);
    const finalQueryString = getFinalQueryString(filters + advancedSearch);

    this.props.getTable(finalQueryString);
    this.props.getCsvData(filters + advancedSearch);
    this.props.setPage({ table: "users", pageNumber: 1 });
    this.props.setSort({ table: "users", sortData: null });

    this.setState({ advancedSearch: data.filters, currentPage: 1 });

    this.props.history.push({
      ...this.props.location,
      search: encodeSearchParams(data.filters, this.state.filters)
    });
  }

  handleSubmitFilters(data) {
    const advancedSearch = parseAdvancedSearch(this.state.advancedSearch);
    const filters = parseFilters(data.filters);
    const finalQueryString = getFinalQueryString(filters + advancedSearch);

    this.props.getTable(finalQueryString);
    this.props.getCsvData(filters + advancedSearch);
    this.props.setPage({ table: "users", pageNumber: 1 });
    this.props.setSort({ table: "users", sortData: null });

    this.setState({ filters: data.filters, currentPage: 1 });

    this.props.history.push({
      ...this.props.location,
      search: encodeSearchParams(this.state.advancedSearch, data.filters)
    });
  }

  onPageChange(pageIndex) {
    window.scrollTo(0, 0);

    const advancedSearch = parseAdvancedSearch(this.state.advancedSearch);
    const filters = parseFilters(this.state.filters);
    const sort = parseSortData(this.props.sortData);
    const pageQuery = getPageQueryString(pageIndex);
    const finalQueryString = getFinalQueryString(
      pageQuery + filters + advancedSearch + sort
    );

    this.props.getTable(finalQueryString);
    this.props.setPage({ table: "users", pageNumber: pageIndex + 1 });

    this.setState({ currentPage: pageIndex + 1 });
  }

  onSortChange(sortData) {
    const advancedSearch = parseAdvancedSearch(this.state.advancedSearch);
    const filters = parseFilters(this.state.filters);
    const sort = parseSortData(sortData);
    const finalQueryString = getFinalQueryString(
      filters + advancedSearch + sort
    );

    this.props.getTable(finalQueryString);
    this.props.setPage({ table: "users", pageNumber: 1 });
    this.props.setSort({ table: "users", sortData });

    this.setState({ currentPage: 1 });
  }

  openAdvancedSearch() {
    this.setState({ showAdvancedSearch: true });
  }

  openFilters() {
    this.setState({ showFilters: true });
  }

  getLink(user, name) {
    if (!user) return null;
    const statusName = _.get(user, "status.name");

    if (
      statusName === "approved" ||
      statusName === "suspended" ||
      statusName === "blocked"
    ) {
      return (
        <Link to={`/admin/member/approved/${user.id}/profile`}>{name}</Link>
      );
    }

    return <Link to={`/admin/member/${user.id}/moderation`}>{name}</Link>;
  }

  getDateLastLogin(date) {
    if (!date) return <div className={styles.none}>—</div>;
    return moment(date).format("MM/DD/YYYY");
  }

  getDateStatusLogId(log, id) {
    if (!log || log.length <= 0) return undefined;
    let date = log.filter(e => e.status_id === id).map(e => e.modified_at);
    if (!date || date.length === 0) return undefined;
    return date.reduce((p, c) => (p > c ? p : c));
  }

  getSkillsCategories(skills) {
    if (!skills || skills.length === 0) return "";
    let categories = [];
    skills.forEach(s => {
      const catName = s.description.category.name;
      if (!categories.includes(catName)) {
        categories.push(catName);
      }
    });
    return categories.join(", ");
  }

  getTableData(target) {
    const users = target === "csv" ? this.props.users_csv : this.props.users;

    let data = users.map(user => {
      return {
        id: user.id,
        first_name: this.getLink(user, user.first_name),
        last_name: this.getLink(user, user.last_name),
        email: this.getLink(user, user.email),
        status: user.status.display_name,
        level: _.get(user.profile, "level.value"),
        metro_area: _.get(user.profile, "commute_city.value"),
        skills_categories: this.getSkillsCategories(user.skills),
        projects_pitched: _.get(user.statistics, "pitched"),
        projects_hired: _.get(user.statistics, "hired"),
        last_login_date: this.getDateLastLogin(user.last_login_at),
        // For filters:
        status_id: user.status_id,
        date_signed_up: moment(
          this.getDateStatusLogId(user.log, STATUS_ID_SIGNED_UP)
        ).format("MM/DD/YYYY"),
        date_approved: this.getDateStatusLogId(user.log, STATUS_ID_APPROVED),
        last_login_at: user.last_login_at,
        skills: _.get(user, "skills"),
        location: _.get(user, "profile.city"),
        metro_area_id: _.get(user, "profile.commute_city.id"),
        referral_type: _.get(user, "profile.referral_type.value"),
        referral_value: _.get(user, "profile.referral_value")
      };
    });

    return data;
  }

  render() {
    return (
      <div>
        <AdvancedSearch
          show={this.state.showAdvancedSearch}
          onClose={() => this.setState({ showAdvancedSearch: false })}
          onSubmit={this.handleSubmitAdvancedSearch}
        />
        <Filters
          show={this.state.showFilters}
          onClose={() => this.setState({ showFilters: false })}
          onSubmit={this.handleSubmitFilters}
        />
        <TableOptions
          title="Members / All"
          paginationCount={this.props.paginationCount}
          onFilterClick={this.openFilters}
          filtersNumber={this.state.filters && this.state.filters.length}
          searchsNumber={
            this.state.advancedSearch && this.state.advancedSearch.length
          }
          tableData={this.getTableData()}
          tableColumns={tableColumns}
          onSearchClick={this.openAdvancedSearch}
        />
        <div className={styles.projects}>
          <AdminTable
            page={this.state.currentPage - 1}
            tableData={this.getTableData()}
            tableColumns={tableColumns}
            loading={this.props.loading}
            selectable={false}
            numberOfPages={this.props.numberOfPages}
            onPageChange={this.onPageChange}
            noRowsText="No members found"
            sortData={this.props.sortData}
            onSortChange={this.onSortChange}
            style={{
              height: "640px" // This will force the table body to overflow and scroll
            }}
          />
        </div>
        <Col
          lg={2}
          md={2}
          sm={2}
          style={{ textAlign: "center", paddingTop: "1.5em" }}
        >
          <TableExportButton
            tableColumns={tableColumns}
            tableData={this.getTableData("csv")}
          />
        </Col>
      </div>
    );
  }
}

export default AdminUsers;



// WEBPACK FOOTER //
// ./src/routes/admin/users/components/AdminUsers.js